import React, { useEffect, useState } from "react";
import ShopsItem from "./ShopsItem";
import { CATEGORY_API } from "./apiurls";
import WineControls from "./WineControls";

import "./PagesLinksSecond.css";

function PagesLinksSecond() {
  const [categories, setCategories] = useState([]);
  const [selectedCatId, setSelectedCatId] = useState("ALL"); 
  const [selectedShops, setSelectedShops] = useState([]);
  const [mlFilter, setMlFilter] = useState({
      sizes: [],
      prices: []
  });
  const [userCoords, setUserCoords] = useState(null);
   const [nearbyShops, setNearbyShops] = useState([]);
   const [searchValue, setSearchValue] = useState("");
const [selectedCatName, setSelectedCatName] = useState("ALL");
  useEffect(() => {
    async function fetchCategories() {
      try {
        const res = await fetch(
          CATEGORY_API
        );
        const data = await res.json();
        setCategories(data);
      } catch (err) {
        console.error(err);
      }
    }
    fetchCategories();
  }, []);

  return (
 

 
    <div className="pages-links-container">
      {/* CATEGORY BUTTONS */}
      
       <WineControls
        catId={selectedCatId}
        catName={selectedCatName}
        cbSearch={setSearchValue}
        cbChangedFilter={(shops) => setSelectedShops(shops)}
        cbChangedSort={setMlFilter}
        cbChangeOutputType={() => {}}
        cbSetUserCoords={setUserCoords}
        cbSetNearbyShops={setNearbyShops}
        selectedCatId={selectedCatId}
        setSelectedCatId={setSelectedCatId}
        setSelectedCatName={setSelectedCatName}
        showCategoryFilter={false}
        showShopFilterInDrawer={true}
        showPriceFilter={true}
      />

      {/* PRODUCTS */}
      <div className="products-card-s">
  {categories.length === 0 ? (
    <p>Loading categories...</p>
  ) : selectedCatId ? (
    <ShopsItem 
    cat_id={selectedCatId} 
    allCategories={categories}  
    selectedShops={selectedShops} 
    mlFilter={mlFilter}  
    nearbyShops={nearbyShops}  
    searchKeyword={searchValue}  />
  ) : (
    <p>Select a category</p>
  )}
</div>
</div>
    
  );
}

export default PagesLinksSecond;
